<template>
    <div class="bg-white rounded h-screen shadow">

        <GoBackButtonRow class="position-relative top-6 left-6" />

        <div class="mt-5 grid grid-cols-2">
            <div class="position-relative">
                <div class="font-bold text-sm bg-white px-1 text-fontColor z-30 position-absolute bottom-8 ml-4">
                    {{ $t('sale.tax.name') }}
                </div>
                <InputBox
                    model-name="name"
                    :model-form="modelForm"
                />
            </div>

            <div class="position-relative pl-0">
                <div class="font-bold text-sm bg-white px-1 text-fontColor z-30 position-absolute bottom-8 ml-4">
                    {{ $t('sale.discount.percentAmount') }}
                </div>
                <InputBox
                    :model-form="modelForm"
                    model-name="percent"
                    :no-margin-top="true"
                    type="number"
                />
            </div>
        </div>

        <div class="row mt-5">
            <div class="col">
                <div class="d-flex justify-content-between">
                    <div class="col-6 col-sm-6 col-md-6">
                        <SubmitRow
                            :is-disabled="checkForDisabling"
                            text="save"
                            sm-size="12"
                            md-size="12"
                            :do-action="addTax"
                            :is-loading="isLoading"
                        />
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import SubmitRow from "@/components/SubmitRow";
import InputBox from "@/components/InputBox";
import '@/style/vue-select.css';
import GoBackButtonRow from "@/components/GoBackButtonRow";

export default {
    name: "TaxesAdd",
    components: {
        InputBox,
        GoBackButtonRow,
        SubmitRow,
    },
    data() {
        return {
            isLoading: false,
            breadcrumbItems:  [
                {name: 'home', url: ''},
                {name: 'sale.title', url: 'sales/sale'},
                {name: 'sale.tax.title', url: 'sales/taxes'},
                {name: 'edit'}
            ],
            modelForm: {
                percent: '',
                name: '',
                company: ''
            },
        }
    },
    computed: {
        ...mapGetters(['getUserCompanyIdAt']),
        checkForDisabling() {
            return !(this.modelForm.name && this.modelForm.percent)
        },
    },
    methods: {
        ...mapActions(['putTax', 'fetchTax', 'pushTax', 'setBreadcrumbItems']),
        addTax() {
            this.$root.showOverlay = true
            this.modelForm.company = this.getUserCompanyIdAt

            if (this.$route.name === "sales/taxes/edit") {
                this.putTax(this.modelForm)
                    .then(() => {
                        this.$root.showOverlay = false
                        this.$i18nHelper.toUrl('sales/taxes')
                    })
                    .catch(() => {
                        this.$root.showOverlay = false
                    })
            } else {
                this.pushTax(this.modelForm)
                    .then(() => {
                        this.$root.showOverlay = false
                        this.$i18nHelper.toUrl('sales/taxes')
                    })
                    .catch(() => {
                        this.$root.showOverlay = false
                    })
            }
        },
    },
    created() {
        this.setBreadcrumbItems(this.breadcrumbItems)
    },
    mounted() {
        this.$root.showOverlay = true

        if (this.$route.name === "sales/taxes/edit") {
            this.fetchTax(this.$route.params.id)
                .then((response) => {
                    this.modelForm.company = response.company
                    this.modelForm.name = response.name
                    this.modelForm.taxId = response.id
                    this.modelForm.percent = response.percent
                })
        }

        this.$root.showOverlay = false
    },
}
</script>

<style scoped>
.text-light span {
    font-size: 12px;
}

</style>
